export function tryGetErrorMessage(error: unknown): string | undefined {
  if (typeof error === 'string') {
    return error;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'object' && error !== null) {
    if ('details' in error) {
      // @ts-ignore
      return tryGetErrorMessage(error.details);
    }
    if ('error' in error) {
      // @ts-ignore
      return tryGetErrorMessage(error.error);
    }
    if ('message' in error) {
      // @ts-ignore
      return tryGetErrorMessage(error.message);
    }
  }

  return undefined;
}

export function getErrorMessageOrDefault(
  error: unknown,
  options?: {defaultMessage?: string},
): string {
  return (
    tryGetErrorMessage(error) ??
    options?.defaultMessage ??
    'An unknown error has occurred'
  );
}
